"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _util = require("@bento-core/util");
var _CTDC_Logo = _interopRequireDefault(require("./CTDC_Logo.svg"));
var _excluded = ["classes"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = function styles() {
  return {
    grow: {
      flexGrow: 3
    },
    searchComp: {
      marginRight: '45px'
    },
    headerBar: function headerBar(props) {
      var defaultProps = {
        color: '#8A95A7',
        width: '100%',
        height: '100px',
        margin: '0 auto',
        display: 'flex',
        position: 'fixed',
        minHeight: '100px',
        justifyContent: 'space-between',
        top: '0px',
        zIndex: '1201',
        background: '#ffffff'
      };
      return Object.assign(defaultProps, props.customStyle.headerBar);
    },
    nihLogoContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    icdcLogoContainer: {
      display: 'flex',
      width: '100%',
      paddingLeft: '24px',
      marginLeft: function marginLeft(props) {
        return props.customStyle.icdcLogoContainerMarginLeft || 'auto';
      },
      background: function background(props) {
        return "url(".concat(props.easter, ")") || '';
      },
      overflow: 'hidden',
      '@media (min-width: 2400px)': {
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      }
    },
    nihLogoImg: function nihLogoImg(props) {
      var defaultProps = {
        minWidth: '200px',
        minHeight: '60px',
        maxHeight: '80px',
        maxWidth: '460px',
        cursor: 'pointer',
        marginLeft: '45px'
      };
      return Object.assign(defaultProps, props.customStyle.nihLogoImg);
    }
  };
};
var Header = function Header(_ref) {
  var classes = _ref.classes,
    props = _objectWithoutProperties(_ref, _excluded);
  var logo = props.logo,
    alt = props.alt,
    homeLink = props.homeLink,
    SearchComponent = props.SearchComponent;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "header",
    className: classes.headerBar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.nihLogoContainer
  }, /*#__PURE__*/_react.default.createElement(_util.RouteLinks, {
    to: homeLink
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.nihLogoImg,
    src: logo,
    alt: alt
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.icdcLogoContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.grow
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.searchComp
  }, /*#__PURE__*/_react.default.createElement(SearchComponent, null))));
};
Header.defaultProps = {
  logo: _CTDC_Logo.default,
  alt: 'NCI CTDC Logo - Clinical Trials Data Commons',
  homeLink: '/',
  customStyle: {},
  SearchComponent: function SearchComponent() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
};
var _default = (0, _core.withStyles)(styles)(Header);
exports.default = _default;